module.exports = __webpack_public_path__ + "static/media/C2.069ea549.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C2.png
// module id = 894
// module chunks = 0